import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { PrescriptionV3PrescriptionTypeEnum } from '@redteclab/api/clients/bully'
import { IconArrowRight } from '@redteclab/icons'

import { Button, Card } from 'base-ui'

import { useOpenableControls } from '../../../generic-hooks'
import { useGlobalConfigContext } from '../../../global-config'
import { priceGetFormattedValueDiscount } from '../../../price'
import { prescriptionAccessorGetPrescriptionLegalNote } from '../../model/prescriptionAccessor/prescriptionAccessorGetPrescriptionLegalNote'
import { useProductPageContext } from '../productPageContext'
import { ProductPrescriptionBonusDialog } from '../ProductPrescriptionBonusDialog/ProductPrescriptionBonusDialog'

type ProductOverviewPrescriptionBonusCardProps = {
  bonus: number
}

export const ProductOverviewPrescriptionBonusCard: FC<
  ProductOverviewPrescriptionBonusCardProps
> = ({ bonus }) => {
  const { currentPrescriptionType } = useProductPageContext()
  const { superScripts } = useGlobalConfigContext()
  const modalControls = useOpenableControls()
  const intl = useIntl()

  return (
    <>
      <Card
        className="flex flex-row justify-between rounded-m bg-light-secondary-medium p-4"
        data-qa-id="product-overview-prescription-bonus-info-banner"
      >
        <div className="flex-col">
          <div className="pb-1 font-medium">
            {currentPrescriptionType ===
            PrescriptionV3PrescriptionTypeEnum.PrivatePrescription ? (
              <FormattedMessage
                id="product.overview.privateBonus.infoBox"
                values={{
                  sup: (
                    <sup key="privateBonusInfoBox">
                      {prescriptionAccessorGetPrescriptionLegalNote(
                        currentPrescriptionType,
                        superScripts,
                      )}
                    </sup>
                  ),
                }}
              />
            ) : null}
            {currentPrescriptionType ===
              PrescriptionV3PrescriptionTypeEnum.InsurancePrescription ||
            currentPrescriptionType ===
              PrescriptionV3PrescriptionTypeEnum.FreePrescription ? (
              <FormattedMessage
                id="product.overview.publicBonus.infoBox"
                values={{
                  sup: (
                    <sup key="publicBonusInfoBox">
                      {prescriptionAccessorGetPrescriptionLegalNote(
                        currentPrescriptionType,
                        superScripts,
                      )}
                    </sup>
                  ),
                }}
              />
            ) : null}
          </div>
          <Button
            data-qa-id="product-overview-prescription-bonus-info-banner-how-it-works-link"
            endIcon={<IconArrowRight />}
            onClick={modalControls.handleOpen}
            size="large"
            variant="text"
          >
            <FormattedMessage id="product.overview.publicBonus.infoBox.howItWorksLink" />
          </Button>
        </div>
        <div className="ml-4 flex size-20 shrink-0 items-center justify-center whitespace-pre rounded-full bg-light-primary-low p-5 text-xl font-medium text-dark-brand">
          {priceGetFormattedValueDiscount(bonus, intl)}
        </div>
      </Card>
      <ProductPrescriptionBonusDialog
        isOpen={modalControls.isOpen}
        onClose={modalControls.handleClose}
      />
    </>
  )
}
